<ng-container *transloco="let t">
    <ion-list lines="none" class="border border-gray-300 rounded-lg !p-0">
        <ion-item [button]="true" [detail]="true" (click)="handleClickOrderType()">
            <ng-container *ngIf="orderType() === OrderType.Delivery">
                <ion-avatar slot="start">
                    <tui-svg src="icon::delivery-man"></tui-svg>
                </ion-avatar>
                <ion-label>
                    <p class="font-semibold">{{ t('delivery_to') }}</p>
                    <p>
                        {{ receiver() ? (receiver() | formattedAddress) : t('enter_the_address_to_receive_goods') }}
                    </p>
                </ion-label>
            </ng-container>
            <ng-container *ngIf="orderType() === OrderType.OrderAtTheTable">
                <ion-avatar slot="start">
                    <tui-svg src="icon::dinner"></tui-svg>
                </ion-avatar>
                <ion-label>
                    <p class="font-semibold">{{ t('at_the_table') }}</p>
                    <p>{{ table() ? (table() | orderTableName) : t('scan_code_to_order') }}</p>
                </ion-label>
                <ion-label class="mr-2" slot="end" *ngIf="table() && table()?.amount_of_people">
                    <span class="text-gray-600 font-medium text-sm">{{
                        t('amount_of_guests', { value: table()!.amount_of_people })
                    }}</span>
                </ion-label>
            </ng-container>
            <ng-container *ngIf="orderType() === OrderType.Pickup">
                <ion-avatar slot="start">
                    <tui-svg src="icon::shop"></tui-svg>
                </ion-avatar>
                <ion-label>
                    <p class="font-semibold">{{ t('pickup') }}</p>
                    <p>{{ shop()?.address }}</p>
                </ion-label>
            </ng-container>
            <ng-container *ngIf="orderType() === OrderType.TakeAway">
                <ion-avatar slot="start">
                    <tui-svg src="icon::take-away"></tui-svg>
                </ion-avatar>
                <ion-label>
                    <p class="font-semibold">{{ t('take_away') }}</p>
                    <p>{{ shop()?.address }}</p>
                </ion-label>
            </ng-container>
            <ng-container *ngIf="orderType() === null">
                <ion-avatar slot="start">
                    <tui-svg src="icon::store"></tui-svg>
                </ion-avatar>
                <ion-label>
                    <p class="font-semibold">{{ t('select_the_form_of_ordering') }}</p>
                </ion-label>
            </ng-container>
        </ion-item>
    </ion-list>
</ng-container>
